/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { TaskDto } from ".././model";

import { customInstance } from "../../lib/api-client";

/**
 * @summary Get All
 */
export const getTask = (signal?: AbortSignal) => {
  return customInstance<TaskDto[]>({ url: `/task`, method: "GET", signal });
};

export const getGetTaskInfiniteQueryKey = () => {
  return ["infinite", `/task`] as const;
};

export const getGetTaskQueryKey = () => {
  return [`/task`] as const;
};

export const getGetTaskInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getTask>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTaskInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTask>>> = ({
    signal,
  }) => getTask(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getTask>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTaskInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTask>>
>;
export type GetTaskInfiniteQueryError = void;

export function useGetTaskInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTask>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getTask>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTask>>,
          TError,
          Awaited<ReturnType<typeof getTask>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTaskInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTask>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getTask>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTask>>,
          TError,
          Awaited<ReturnType<typeof getTask>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTaskInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTask>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getTask>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All
 */

export function useGetTaskInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTask>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getTask>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTaskInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetTaskQueryOptions = <
  TData = Awaited<ReturnType<typeof getTask>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTaskQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTask>>> = ({
    signal,
  }) => getTask(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetTaskQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTask>>
>;
export type GetTaskQueryError = void;

export function useGetTask<
  TData = Awaited<ReturnType<typeof getTask>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTask>>,
          TError,
          Awaited<ReturnType<typeof getTask>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTask<
  TData = Awaited<ReturnType<typeof getTask>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTask>>,
          TError,
          Awaited<ReturnType<typeof getTask>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTask<
  TData = Awaited<ReturnType<typeof getTask>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All
 */

export function useGetTask<
  TData = Awaited<ReturnType<typeof getTask>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTaskQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create
 */
export const postTask = (taskDto: TaskDto, signal?: AbortSignal) => {
  return customInstance<TaskDto>({
    url: `/task`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: taskDto,
    signal,
  });
};

export const getPostTaskMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTask>>,
    TError,
    { data: TaskDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTask>>,
  TError,
  { data: TaskDto },
  TContext
> => {
  const mutationKey = ["postTask"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTask>>,
    { data: TaskDto }
  > = (props) => {
    const { data } = props ?? {};

    return postTask(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTask>>
>;
export type PostTaskMutationBody = TaskDto;
export type PostTaskMutationError = void;

/**
 * @summary Create
 */
export const usePostTask = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postTask>>,
      TError,
      { data: TaskDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postTask>>,
  TError,
  { data: TaskDto },
  TContext
> => {
  const mutationOptions = getPostTaskMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update
 */
export const putTaskId = (id: number, taskDto: TaskDto) => {
  return customInstance<TaskDto>({
    url: `/task/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: taskDto,
  });
};

export const getPutTaskIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putTaskId>>,
    TError,
    { id: number; data: TaskDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putTaskId>>,
  TError,
  { id: number; data: TaskDto },
  TContext
> => {
  const mutationKey = ["putTaskId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putTaskId>>,
    { id: number; data: TaskDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return putTaskId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutTaskIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putTaskId>>
>;
export type PutTaskIdMutationBody = TaskDto;
export type PutTaskIdMutationError = void;

/**
 * @summary Update
 */
export const usePutTaskId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putTaskId>>,
      TError,
      { id: number; data: TaskDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putTaskId>>,
  TError,
  { id: number; data: TaskDto },
  TContext
> => {
  const mutationOptions = getPutTaskIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get By Id
 */
export const getTaskId = (id: number, signal?: AbortSignal) => {
  return customInstance<TaskDto>({ url: `/task/${id}`, method: "GET", signal });
};

export const getGetTaskIdInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/task/${id}`] as const;
};

export const getGetTaskIdQueryKey = (id?: number) => {
  return [`/task/${id}`] as const;
};

export const getGetTaskIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getTaskId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getTaskId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTaskIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskId>>> = ({
    signal,
  }) => getTaskId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getTaskId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTaskIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTaskId>>
>;
export type GetTaskIdInfiniteQueryError = void;

export function useGetTaskIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTaskId>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getTaskId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskId>>,
          TError,
          Awaited<ReturnType<typeof getTaskId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTaskIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTaskId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getTaskId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskId>>,
          TError,
          Awaited<ReturnType<typeof getTaskId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTaskIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTaskId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getTaskId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get By Id
 */

export function useGetTaskIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTaskId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getTaskId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTaskIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetTaskIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getTaskId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTaskId>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTaskIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskId>>> = ({
    signal,
  }) => getTaskId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getTaskId>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetTaskIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTaskId>>
>;
export type GetTaskIdQueryError = void;

export function useGetTaskId<
  TData = Awaited<ReturnType<typeof getTaskId>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTaskId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskId>>,
          TError,
          Awaited<ReturnType<typeof getTaskId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTaskId<
  TData = Awaited<ReturnType<typeof getTaskId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTaskId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskId>>,
          TError,
          Awaited<ReturnType<typeof getTaskId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTaskId<
  TData = Awaited<ReturnType<typeof getTaskId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTaskId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get By Id
 */

export function useGetTaskId<
  TData = Awaited<ReturnType<typeof getTaskId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTaskId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTaskIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete
 */
export const deleteTaskId = (id: number) => {
  return customInstance<boolean>({ url: `/task/${id}`, method: "DELETE" });
};

export const getDeleteTaskIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTaskId>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTaskId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteTaskId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTaskId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTaskId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTaskIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTaskId>>
>;

export type DeleteTaskIdMutationError = void;

/**
 * @summary Delete
 */
export const useDeleteTaskId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteTaskId>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteTaskId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteTaskIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get All By Deliver Object Id
 */
export const getTaskIdDeliverobject = (id: number, signal?: AbortSignal) => {
  return customInstance<TaskDto[]>({
    url: `/task/${id}/deliverobject`,
    method: "GET",
    signal,
  });
};

export const getGetTaskIdDeliverobjectInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/task/${id}/deliverobject`] as const;
};

export const getGetTaskIdDeliverobjectQueryKey = (id?: number) => {
  return [`/task/${id}/deliverobject`] as const;
};

export const getGetTaskIdDeliverobjectInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getTaskIdDeliverobject>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getTaskIdDeliverobject>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTaskIdDeliverobjectInfiniteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTaskIdDeliverobject>>
  > = ({ signal }) => getTaskIdDeliverobject(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getTaskIdDeliverobject>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTaskIdDeliverobjectInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTaskIdDeliverobject>>
>;
export type GetTaskIdDeliverobjectInfiniteQueryError = void;

export function useGetTaskIdDeliverobjectInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTaskIdDeliverobject>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getTaskIdDeliverobject>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskIdDeliverobject>>,
          TError,
          Awaited<ReturnType<typeof getTaskIdDeliverobject>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTaskIdDeliverobjectInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTaskIdDeliverobject>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getTaskIdDeliverobject>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskIdDeliverobject>>,
          TError,
          Awaited<ReturnType<typeof getTaskIdDeliverobject>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTaskIdDeliverobjectInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTaskIdDeliverobject>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getTaskIdDeliverobject>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All By Deliver Object Id
 */

export function useGetTaskIdDeliverobjectInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTaskIdDeliverobject>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getTaskIdDeliverobject>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTaskIdDeliverobjectInfiniteQueryOptions(
    id,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetTaskIdDeliverobjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getTaskIdDeliverobject>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTaskIdDeliverobject>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTaskIdDeliverobjectQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTaskIdDeliverobject>>
  > = ({ signal }) => getTaskIdDeliverobject(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTaskIdDeliverobject>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTaskIdDeliverobjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTaskIdDeliverobject>>
>;
export type GetTaskIdDeliverobjectQueryError = void;

export function useGetTaskIdDeliverobject<
  TData = Awaited<ReturnType<typeof getTaskIdDeliverobject>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTaskIdDeliverobject>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskIdDeliverobject>>,
          TError,
          Awaited<ReturnType<typeof getTaskIdDeliverobject>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTaskIdDeliverobject<
  TData = Awaited<ReturnType<typeof getTaskIdDeliverobject>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTaskIdDeliverobject>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskIdDeliverobject>>,
          TError,
          Awaited<ReturnType<typeof getTaskIdDeliverobject>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTaskIdDeliverobject<
  TData = Awaited<ReturnType<typeof getTaskIdDeliverobject>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTaskIdDeliverobject>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All By Deliver Object Id
 */

export function useGetTaskIdDeliverobject<
  TData = Awaited<ReturnType<typeof getTaskIdDeliverobject>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTaskIdDeliverobject>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTaskIdDeliverobjectQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
